__webpack_require__.p = "/kunal/";